import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { createInitialRecord } from 'shared/helpers/utils';
import { TScheduleData } from 'shared/types/vacation-schedule.types';

type TInitialValuesCards = {
  employees: TScheduleData[] | null;
  isUploadTo1S: boolean;
  calendarTotalDays: number | null;
  firstRange: string | null;
  divisionId: string;
  filterEmployees: string;
  filterRequestStatuses: boolean;
  active: boolean;
  currentDiuvisionId: string | null;
  initialEmployeeRecord: string;
  initialStatus: boolean;
};

const initialState: TInitialValuesCards = {
  employees: null,
  isUploadTo1S: false,
  calendarTotalDays: null,
  firstRange: null,
  // фильтр
  divisionId: '',
  filterEmployees: 'all',
  filterRequestStatuses: false,
  active: false,
  // triggers
  initialEmployeeRecord: '',
  initialStatus: true,
  currentDiuvisionId: null,
};

export const vacationScheduleSlice = createSlice({
  name: 'ui/vacationSchedule',
  initialState,
  reducers: {
    setEmployees(state, { payload }: PayloadAction<TScheduleData[]>) {
      return { ...state, employees: payload };
    },
    isUploadTo1S(state, { payload }: PayloadAction<boolean>) {
      return { ...state, isUploadTo1S: payload };
    },
    calendarTotalDays(state, { payload }: PayloadAction<number | null>) {
      return { ...state, calendarTotalDays: payload };
    },
    firstRange(state, { payload }: PayloadAction<string | null>) {
      return { ...state, firstRange: payload };
    },
    currentDivisionId(state, { payload }: PayloadAction<string>) {
      return { ...state, currentDiuvisionId: payload };
    },
    // фильтр
    divisionId(state, { payload }: PayloadAction<string>) {
      return { ...state, divisionId: payload };
    },
    filterEmployees(state, { payload }: PayloadAction<string>) {
      return { ...state, filterEmployees: payload };
    },
    filterRequestStatuses(state, { payload }: PayloadAction<boolean>) {
      return { ...state, filterRequestStatuses: payload };
    },
    active(state, { payload }: PayloadAction<boolean>) {
      return { ...state, active: payload };
    },
    setInitialEmployeesRecord(state, { payload }: PayloadAction<string>) {
      return { ...state, initialEmployeeRecord: payload };
    },
    setInitialEmployeesStatus(state, { payload }: PayloadAction<boolean>) {
      return { ...state, initialStatus: payload };
    },
    isInitialEmployeesRecord(state) {
      if (state.initialEmployeeRecord !== createInitialRecord(state.employees)) {
        return { ...state, initialStatus: false };
      }
    },
    resetFilters(state) {
      return {
        ...state,
        divisionId: initialState.divisionId,
        filterEmployees: initialState.filterEmployees,
        filterRequestStatuses: initialState.filterRequestStatuses,
        active: initialState.active,
        currentDiuvisionId: initialState.currentDiuvisionId,
      };
    },
    reset: () => initialState,
  },
});

const selectVacationSchedule = (state: RootState) => state.ui.vacationSchedule;
const getEmployees = createSelector(selectVacationSchedule, ({ employees }) => employees);
const getFiltersState = createSelector(
  selectVacationSchedule,
  ({ divisionId, filterEmployees, filterRequestStatuses, active }) => ({
    divisionId,
    filterEmployees,
    filterRequestStatuses,
    active,
  }),
);
export const selectors = { selectVacationSchedule, getEmployees, getFiltersState };
export const actions = vacationScheduleSlice.actions;
export const reducer = vacationScheduleSlice.reducer;
